'use client';

import { LotteryGoodsModal as CommonLotteryGoodsModal } from '@monorepo/common';

function LotteryGoodsModal() {
  return <CommonLotteryGoodsModal />;
}

export default LotteryGoodsModal;
